import React, { useContext, useEffect, useState } from 'react';
import classes from './NoteSection.module.scss';
import { modalContext } from '@/context/modal.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@/components/Button/Button';
import NoteBlock from './NoteBlock';
import Note from '@/utils/api/odas/note';
import t from '@/utils/Language/UI-translations';

const DISPLAY_MIN = 5;

const NoteSection = ({ resource, account }) => {
  const modal = useContext(modalContext);
  const [notes, setNotes] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [fetching, setFetching] = useState(true);

  const displayedNotes = isExpanded ? notes : notes.slice(0, DISPLAY_MIN);
  const hasMore = notes.length > DISPLAY_MIN;

  useEffect(() => {
    fetchNotes();
  }, [resource.id]);

  const fetchNotes = async () => {
    try {
      const response = await Note.getNotes(resource.id, resource.resource_type);
      setNotes(response?.data?.notes ?? []);
    } catch {
      // notes are non-critical; silently fail
    } finally {
      setFetching(false);
    }
  };

  const openAddNote = () => {
    if (account.state.isLoggedIn) {
      modal.enqueueModal({
        name: 'NewAndEditNoteModal',
        action: 'New',
        resource: resource,
        account: account,
        onNoteAdded: (note) => setNotes((prev) => [note, ...prev])
      });
    } else {
      modal.enqueueModal({ name: 'SignupModal' }, { forceOpen: true });
    }
  };

  const handleEdit = (note) => {
    modal.enqueueModal({
      name: 'NewAndEditNoteModal',
      action: 'Edit',
      note: note,
      resource: resource,
      account: account,
      onNoteUpdated: (updated) => setNotes((prev) => prev.map((n) => (n.id === updated.id ? updated : n)))
    });
  };

  const handleDelete = (noteId) => {
    setNotes((prev) => prev.filter((n) => n.id !== noteId));
  };

  return (
    <div className={classes.noteSection} id="opportunity-notes">
      <div className={classes.noteSectionPanel}>
        <div className={classes.noteSectionHeader}>
          <div className={classes.noteSectionTitleWrapper}>
            <FontAwesomeIcon icon={['far', 'note-sticky']} className={classes.noteSectionIcon} />
            <h2 className={classes.noteSectionTitle}>{t('Notes')}</h2>
          </div>
          <Button type="link" text={t('+ Add a note')} additionalClasses={classes.addNoteBtn} onButtonClick={openAddNote} />
        </div>
        <div className={classes.noteSectionContent}>
          {!fetching && notes.length === 0 && <p className={classes.emptyState} dangerouslySetInnerHTML={{ __html: t('Notes explanation') }} />}
          {displayedNotes.map((note) => (
            <NoteBlock key={note.id} note={note} resource={resource} account={account} onEdit={handleEdit} onDelete={handleDelete} />
          ))}
          {hasMore && (
            <div className={classes.toggleWrapper}>
              <Button
                type="link"
                text={isExpanded ? t('Hide notes') : t('Show all notes')}
                additionalClasses={classes.toggleBtn}
                onButtonClick={() => setIsExpanded(!isExpanded)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoteSection;
